<script setup lang="ts">
import { useThemeStore } from "@/store/modules/theme";
import { useFootStore } from "@/store/modules/layoutFoot";
const footStore = useFootStore();

defineOptions({
  name: "GlobalFooter",
});
const themeStore = useThemeStore();

function handleConfirmClick() {
  themeStore.confirmClickFlag++;
}
function handleBackClick() {
  themeStore.backClickFlag++;
}
</script>

<template>
  <div class="h-full flex-center bg-white">
    <NButton
      class="min-w-96px mx-12px"
      strong
      secondary
      @click="handleBackClick"
      v-show="themeStore.footer.content.back"
      :disabled="themeStore.footer.content.backDisabled"
      >{{ themeStore.footer.content.backLabel }}</NButton
    >
    <NButton
      class="min-w-96px mx-12px"
      type="primary"
      @click="handleConfirmClick"
      v-show="themeStore.footer.content.confirm"
      :disabled="themeStore.footer.content.confirmDisabled"
      :loading="footStore.footLoading"
      >{{ themeStore.footer.content.confirmLabel }}</NButton
    >
  </div>
</template>

<style scoped></style>
